<template>
    <div class="error-msg-wrap">
        <div class="form-wrapper slide-up">
            <div class="form-close">
                <button type="button" class="form-close-x" title="Close" @click="$emit('close')">&times;</button>
            </div>
            <h3 style="margin-bottom:15px">View Checklist As</h3>
            <input type="text" v-model="searchQ" placeholder="Search by name" />
            <div style="margin-top:15px;max-height:400px;overflow:auto">
                <div v-if="!filteredEmployees.length" style="font-size:12px;color:#a8a4a0;padding:10px 0">No employees found.</div>
                <div v-for="(e, i) in filteredEmployees" :key="i" @click="selectEmployee(e)" class="cl-card" style="cursor:pointer;margin-bottom:8px">
                    <div style="flex:1">
                        <div class="cl-nm">{{ e.Name }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import axios from 'axios';

export default defineComponent({
    name: 'ViewAsUserPicker',
    data() {
        return {
            searchQ: '',
            employees: [] as any[]
        }
    },
    computed: {
        filteredEmployees(): any[] {
            if(this.searchQ.trim().length < 3) {
                return this.employees;
            }
            const q = this.searchQ.trim().toLowerCase();
            return this.employees.filter((e: any) => (e.Name || '').toLowerCase().includes(q));
        }
    },
    async created() {
        await axios.get(`${this.$store.state.apiUrl}/api/employees`)
            .then(resp => { this.employees = resp.data; })
            .catch(() => { this.employees = []; })
    },
    methods: {
        selectEmployee(e: any) {
            this.$emit('select', { targetEmployeeID: e.ID, name: e.Name });
        }
    }
});
</script>
